import React, { useMemo, type CSSProperties } from "react";
import { CardTypeEnum } from "../../../../client/api";

type CardIconProps = {
  type: CardTypeEnum;
  width: number;
};

const CardIcon: React.FC<CardIconProps> = ({ type, width }) => {
  const isYellowRed = type === CardTypeEnum.YELLOW_RED;

  const baseStyle = useMemo<CSSProperties>(() => {
    const height = width * 1.333;
    return {
      position: "relative",
      width,
      height,
      borderRadius: 2,
      marginLeft: isYellowRed ? width / 1.5 : 0,
    };
  }, [width, isYellowRed]);

  const overlayStyle = useMemo<CSSProperties>(() => {
    const height = width * 1.333;
    return {
      position: "absolute",
      width,
      height,
      left: -width / 1.5,
      bottom: width * 0.08,
      borderRadius: 2,
      transform: "rotate(-30deg)",
      transformOrigin: "center",
    };
  }, [width]);

  return (
    <div
      style={baseStyle}
      className={type === CardTypeEnum.RED ? "bg-red-card" : "bg-yellow-card"}
    >
      {isYellowRed && <div style={overlayStyle} className="bg-red-card" />}
    </div>
  );
};

export default CardIcon;
